import { RouterName } from "./router-name";

export const enum NavName {
  Home = "首页",
  // SongSheet = "歌单",
  songStyle = "曲风",
  // Singer = "歌手",
  musicalCycleClass = "套曲",
  // privateCustomization = "私人定制",
  entryPlatform = "音乐人入驻",
  Personal = "个人主页",
  Setting = "设置",
  memberCenter = "VIP",
  SignIn = "登录/注册",
  SignUp = "注册",
  SignOut = "退出",
  PayRecord = "我的支付",
  DownloadRecord = "下载记录",
  MyCollection = "我的收藏",
  Playlists = "播放列表",
}

// 左侧导航栏
export const HEADERNAVLIST = [
  {
    name: NavName.Home,
    path: RouterName.Home,
  },
 /* {
    name: NavName.songStyle,
    path: RouterName.songStyle,
  },*/
  {
    name: NavName.musicalCycleClass,
    path: RouterName.songCycle,
  },
/*  {
    name: NavName.privateCustomization,
    path: RouterName.privateCustomization,
  },*/
  {
    name: NavName.entryPlatform,
    path: RouterName.entryPlatform,
  },
  /*{
    name: NavName.memberCenter,
    path: RouterName.memberCenter,
  },*/
];

// 右侧导航栏
export const SIGNLIST = [
  {
    name: NavName.SignIn,
    path: RouterName.SignIn,
  },
/*  {
    name: NavName.SignUp,
    path: RouterName.SignUp,
  },*/
];

// 用户下拉菜单项
export const MENULIST = [
  {
    name: NavName.Personal,
    path: RouterName.Personal,
  },
  /*{
    name: NavName.PayRecord,
    path: RouterName.PayRecord
  },
  {
    name: NavName.DownloadRecord,
    path: RouterName.DownloadRecord
  },
  {
    name: NavName.Setting,
    path: RouterName.Setting,
  },*/
  {
    name: NavName.PayRecord,
    path: RouterName.PayRecord,
  },
  {
    name: NavName.DownloadRecord,
    path: RouterName.DownloadRecord,
  },
  {
    name: NavName.MyCollection,
    path: RouterName.MyCollection,
  },
/*  {
    name: NavName.Playlists,
    path: RouterName.Playlists,
  },*/
  {
    name: NavName.SignOut,
    path: RouterName.SignOut,
  },
];
